import { GetAllFaseAvvioFiltersDTO, GetAllFaseAvvioResponseData, GetAllFaseAvvioResponseDTO } from "./dto";
import { MonitoringFaseAvvioImpl } from "./serviceImpl";

export interface MonitoringFaseAvvioService {
    GetAllFaseAvvio(filters: GetAllFaseAvvioFiltersDTO): Promise<GetAllFaseAvvioResponseData[]>
}

export function NewMonitoringFaseAvvioService(): MonitoringFaseAvvioService {
    return new MonitoringFaseAvvioImpl()
}